(() => {
  const baseLanguage = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const shouldReplaceMarketingCopy = baseLanguage === 'en';
  const replacements = [
    {
      pattern: /Enter\s+your\s+email\s+to\s+get\s+an\s+extra\s+10%\s+off\s+your\s+first\s+Gueray\s+order\.?/gi,
      value: 'Enter your email to subscribe and receive 10% off your order.',
    },
    {
      pattern: /Unlock\s+(?:an\s+)?Extra\s+10%\s+Off/gi,
      value: 'Subscribe & Get 10% Off',
    },
    {
      pattern: /Get\s+Extra\s+10%\s+Off/gi,
      value: '10% Off',
    },
  ];

  const excludedParents = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const replacementTrigger = /(?:Enter\s+your\s+email\s+to\s+get\s+an\s+extra\s+10%\s+off|Unlock\s+(?:an\s+)?Extra\s+10%\s+Off|Get\s+Extra\s+10%\s+Off)/i;
  const chatStyleId = 'gueray-compact-chat-style';
  const pendingNodes = new Set();
  let flushTimer = 0;

  function stabilizeAppImages(root) {
    if (!root || (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE)) {
      return;
    }

    const images = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('img')) images.push(root);
    root.querySelectorAll?.('img').forEach((image) => images.push(image));

    images.forEach((image) => {
      const source = image.currentSrc || image.src || '';
      let dimensions = null;

      if (source.includes('static.ecomsend.com') && image.alt === 'roulette-static') {
        dimensions = [68, 38];
      } else if (source.includes('files.ecomsend.com') && image.alt === 'logo') {
        dimensions = [125, 35];
      }

      if (!dimensions) return;
      if (!image.hasAttribute('width')) image.width = dimensions[0];
      if (!image.hasAttribute('height')) image.height = dimensions[1];
      image.decoding = 'async';
    });
  }

  function styleChatHost(host) {
    if (!host?.shadowRoot) return false;
    const roots = [host.shadowRoot];
    let styled = false;

    while (roots.length) {
      const root = roots.shift();
      if (!root.getElementById(chatStyleId)) {
        const style = document.createElement('style');
        style.id = chatStyleId;
        style.textContent = `
          @media (max-width: 749px) {
            .activator-nudge {
              transition: bottom 280ms cubic-bezier(.22, 1, .36, 1) !important;
            }
            .activator {
              width: 46px !important;
              min-width: 46px !important;
              height: 46px !important;
              padding: 0 !important;
              justify-content: center !important;
              border-radius: 50% !important;
            }
            .activator__label { display: none !important; }
          }
        `;
        root.appendChild(style);
        styled = true;
      }

      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });
    }

    return styled;
  }

  function compactShopifyChat(scope = document) {
    const hosts = [];
    if (scope instanceof Element && scope.matches('shopify-chat')) hosts.push(scope);
    scope.querySelectorAll?.('shopify-chat').forEach((host) => hosts.push(host));
    hosts.forEach(styleChatHost);
  }

  function replaceTextNode(node) {
    if (!shouldReplaceMarketingCopy) return;
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    if (node.parentElement && excludedParents.has(node.parentElement.tagName)) return;

    let nextValue = node.nodeValue;
    replacements.forEach(({ pattern, value }) => {
      nextValue = nextValue.replace(pattern, value);
    });

    if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    stabilizeAppImages(root);
    compactShopifyChat(root);

    // App embeds add many unrelated subtrees. Only walk text when an exact
    // storefront phrase that needs correction is actually present.
    if (!shouldReplaceMarketingCopy || !replacementTrigger.test(root.textContent || '')) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      replaceTextNode(textNode);
      textNode = walker.nextNode();
    }
  }

  function flushPendingNodes() {
    flushTimer = 0;
    const nodes = Array.from(pendingNodes);
    pendingNodes.clear();
    nodes.forEach(scan);
  }

  function queueScan(node) {
    if (!node) return;
    pendingNodes.add(node);
    if (flushTimer) return;
    flushTimer = window.setTimeout(flushPendingNodes, 50);
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  function start() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(queueScan));
    });

    observer.observe(document.body, { childList: true, subtree: true });
    runWhenIdle(() => scan(document.body));

    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined('shopify-chat').then(() => compactShopifyChat(document));
    }

    window.setTimeout(() => observer.disconnect(), 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(() => {
  const formSelector = '.gy-product-form';
  const activeForms = new WeakSet();

  function formStatus(form) {
    let status = form.querySelector('[data-gy-product-form-status]');
    if (status) return status;

    status = document.createElement('p');
    status.hidden = true;
    status.setAttribute('role', 'alert');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('data-gy-product-form-status', '');
    status.style.margin = '12px 0 0';
    status.style.color = '#b3261e';
    status.style.fontSize = '14px';
    form.appendChild(status);
    return status;
  }

  function cartTarget() {
    const target = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!target || typeof target.getSectionsToRender !== 'function' || typeof target.renderContents !== 'function') {
      return null;
    }
    return target;
  }

  function cartPageUrl() {
    const localizedRoot = window.Shopify?.routes?.root || '/';
    return window.routes?.cart_url || `${localizedRoot}cart`;
  }

  function sectionsCanRender(cart, result, sectionIds) {
    if (!result?.sections || !sectionIds.every((id) => typeof result.sections[id] === 'string' && result.sections[id])) {
      return false;
    }

    if (cart.tagName === 'CART-DRAWER') {
      return Boolean(new DOMParser()
        .parseFromString(result.sections['cart-drawer'], 'text/html')
        .querySelector('#CartDrawer'));
    }

    return true;
  }

  async function submitWithCartDrawer(event) {
    const form = event.currentTarget;
    const cart = cartTarget();
    if (!cart) return;

    event.preventDefault();
    if (activeForms.has(form)) return;
    const submitButton = event.submitter || form.querySelector('[data-gy-submit], button[type="submit"]');
    if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    activeForms.add(form);
    const status = formStatus(form);
    status.hidden = true;
    status.textContent = '';
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.classList.add('is-loading');

    let mutationState = 'unknown';
    try {
      const formData = new FormData(form);
      const sections = cart.getSectionsToRender().map((section) => section.id);
      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
      cart.setActiveElement?.(submitButton);

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers = config.headers || {};
      config.headers.Accept = 'application/json';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const localizedRoot = window.Shopify?.routes?.root || '/';
      const addUrl = window.routes?.cart_add_url || `${localizedRoot}cart/add.js`;
      const response = await fetch(addUrl, config);
      const result = await response.json();
      if (!response.ok || result.status) {
        mutationState = 'rejected';
        throw new Error(result.description || result.message || window.cartStrings?.error || 'Unable to add this item to your cart.');
      }
      mutationState = 'succeeded';

      // A successful add must never be presented as a failed add merely
      // because the Section Rendering response is incomplete. Send the
      // customer to the locale-aware cart instead, where the added line is
      // visible and cannot be accidentally submitted a second time.
      if (!sectionsCanRender(cart, result, sections)) {
        window.location.assign(cartPageUrl());
        return;
      }

      if (
        typeof publish === 'function'
        && typeof PUB_SUB_EVENTS !== 'undefined'
        && PUB_SUB_EVENTS?.cartUpdate
      ) {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gueray-product-form',
          productVariantId: formData.get('id'),
          cartData: result,
        })).catch((error) => {
          console.warn('Unable to notify cart subscribers after add-to-cart.', error);
        });
      }

      // The drawer may have rendered its empty-state shell before the first
      // add. Clear that state before replacing the section HTML; otherwise
      // Dawn's `.is-empty .cart__contents` rule hides the newly added line.
      cart.classList.remove('is-empty');
      cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
      cart.renderContents(result);
      form.dispatchEvent(new CustomEvent('gueray:cart-added', {
        bubbles: true,
        detail: { cart: result },
      }));
    } catch (error) {
      if (mutationState !== 'rejected') {
        window.location.assign(cartPageUrl());
        return;
      }
      status.textContent = error?.message || window.cartStrings?.error || 'Unable to add this item to your cart.';
      status.hidden = false;
      form.dispatchEvent(new CustomEvent('gueray:cart-error', {
        bubbles: true,
        detail: { error },
      }));
    } finally {
      activeForms.delete(form);
      submitButton.removeAttribute('aria-disabled');
      submitButton.removeAttribute('aria-busy');
      submitButton.classList.remove('is-loading');
    }
  }

  function initializeForms(scope = document) {
    const forms = [];
    if (scope instanceof Element && scope.matches(formSelector)) forms.push(scope);
    scope.querySelectorAll?.(formSelector).forEach((form) => forms.push(form));

    forms.forEach((form) => {
      if (form.dataset.gyAjaxCartReady === 'true') return;
      form.dataset.gyAjaxCartReady = 'true';
      form.addEventListener('submit', submitWithCartDrawer);
    });
  }

  function start() {
    initializeForms(document);
    document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
